import { FC } from "react"
import { useTranslation } from "react-i18next"

import Button from "components/Button/Button"
import { Flex, FlexItem } from "components/Flex"
import Modal from "components/Modal/Modal"

interface IViewSettingsModalProps {
    isDefault: boolean
    onResetToDefault(): void
    onClose(): void
    onSave(): void
}

const ViewSettingsModal: FC<React.PropsWithChildren<IViewSettingsModalProps>> = ({
    isDefault,
    onResetToDefault,
    onClose,
    onSave,
    children,
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            title={t("viewSettings.viewSettings")}
            maxWidth="586px"
            onClose={onClose}
            footer={
                <Flex alignItems="center" justifyContent="space-between">
                    <FlexItem>
                        {!isDefault &&
                            <Button
                                label={t("viewSettings.resetToDefault")}
                                theme="link"
                                onClick={onResetToDefault} />
                        }
                    </FlexItem>
                    <Flex>
                        <Button
                            theme="secondary"
                            label={t("common.cancel")}
                            onClick={onClose} />
                        <Button
                            label={t("common.save")}
                            onClick={onSave}
                            className="ml-2" />
                    </Flex>
                </Flex>
            }>
            {children}
        </Modal>
    )
}

export default ViewSettingsModal
